import React, { memo, useEffect, useState, useCallback } from 'react';
import ListContainer from '../../../../../shared/components/ListContainer';
import SVG from 'react-inlinesvg';
import styles from '../../gpsLoader.module.scss';
import { transmissionValidatorSVG } from '../../../../../shared/helpers/icons';
import { defaultPath } from '../../../../../transmissionValidator/routes';

const ListGps = ({
  gps_devices,
  fetching,
  totalItems,
  fetchingMoreItems,
  onScrollBottomAction,
  submitSuccess,
  setGpsSelected,
  history,
  enableCheckboxes = false,
  selectedRows = [],
  onSelectRow = () => {},
  onGpsRowClick = null
}) => {
  const [isOpenDialog, setIsOpenDialog] = useState(false);

  const handleGpsClick = gps_device => {
    if (typeof onGpsRowClick === 'function') {
      onGpsRowClick(gps_device);
      return;
    }
    if (typeof setGpsSelected === 'function') {
      setGpsSelected(gps_device);
    }
    if (history && typeof history.push === 'function') {
      history.push(`/stock/gps/${gps_device.name}`);
    } else if (typeof history === 'function') {
      history(`/stock/gps/${gps_device.name}`);
    }
  };


  const handleOpenDialog = gps_device => {
    setGpsSelected(gps_device);
    setIsOpenDialog(true);
};

const handleCloseDialog = useCallback(() => {
    setGpsSelected();
    setIsOpenDialog(false);
}, [setGpsSelected]);

  useEffect(() => {
    if (submitSuccess) {
        handleCloseDialog();
    }
}, [submitSuccess, handleCloseDialog]);

const getCssClassFromStatusName = (name) => {
  if (!name) return '';

  const map = {
    'desinstalado - terreno': 'desinstalado-terreno',
    'bodega - lab': 'bodega-lab',
  };

  const cleaned = name.trim().toLowerCase();

  return map[cleaned] || cleaned.replace(/\s+/g, '-');
};

  return (
    <ListContainer
      skeletonColumn={6}
      loading={fetching}
      totalItems={totalItems}
      fetchingMoreItems={fetchingMoreItems}
      onScrollBottomAction={onScrollBottomAction}
    >
      {gps_devices.map(gps => (
        <div
          key={gps._id}
          className={styles.row}
          onClick={() => handleGpsClick(gps)}
        >
          {enableCheckboxes && (
            <div className={styles.checkboxCell} onClick={(e) => e.stopPropagation()}>
              <input
                type="checkbox"
                checked={selectedRows.includes(gps._id)}
                onChange={e => onSelectRow(gps._id, e.target.checked)}
                onClick={e => e.stopPropagation()}
              />
            </div>
          )}
          <div> {gps.created || '-'} </div>
          <div> {gps.name} </div>
          <div> {gps.device?.model_name || '-'} </div>
          <div> {gps.device?.imei || '-'} </div>
          <div> {gps.simcard?.iccid || '-'} </div>
          <div className={styles.textAlignCenter}>
            {gps.protocol || '-'}
          </div>
          <div className={styles.statusCell}>
          <span
            className={`
              ${styles.status}
              ${styles[getCssClassFromStatusName(gps.status?.name)]}
            `}
          >
            {gps.status?.name}
          </span>

            {gps.status?.name?.toLowerCase() !== 'baja' && gps.status?.name?.toLowerCase() !== 'ok' && (
              <span className={styles.arrow}>›</span>
            )}
          </div>
                  <div
          className={`
            ${styles.subStatus}
            ${
              gps.substatus?.value &&
              gps.substatus.value.toLowerCase() !== 'sin subestado'
                ? styles[getCssClassFromStatusName(gps.status?.name)]
                : ''
            }
          `}
        >
          {gps.substatus?.value &&
          gps.substatus.value.toLowerCase() !== 'sin subestado'
            ? gps.substatus.value
            : ''}
        </div>

          <div className={styles.textAlignCenter}>
            <SVG
              src={gps.enabledIcon}
              className={`${styles.svg} ${
                gps.enabled ? styles.enabled : styles.disabled
              }`}
            />
          </div>
        </div>
      ))}
    </ListContainer>
  );
};

export default memo(ListGps);
